import React from "react";
import { Tutorial } from "@/assets";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { WelcomeSection } from "../WelcomeSection";
import { FormDescription } from "../FormDescription";

interface PageFieldProps {
  title?: string;
  text?: string;
  videoUrl?: string;
  label?: string;
  description?: string;
  value?: any;
  onChange?: (value: any) => void;
  hasErrors?: boolean;
  required?: boolean;
  activeStep?: number;
  totalSteps?: number;
}

export const PageField: React.FC<PageFieldProps> = ({ 
  title, 
  text, 
  videoUrl,
  label,
  description,
  value,
  onChange,
  hasErrors,
  required,
  activeStep,
  totalSteps
}) => {
  // Use title o label para o título da seção, priorizando title se ambos estiverem definidos
  const displayTitle = title || label || "";
  
  // Use text ou description para o conteúdo, priorizando text se ambos estiverem definidos
  const displayText = text || description || "";
  
  return (
    <>
      <WelcomeSection 
        title={displayTitle}
        subtitle={""}
        description={""}
      />
      <FormDescription 
        title={""}
        text={displayText}
      />
    </>
  );
};
